import { StatusCodes } from 'http-status-codes';
import React, { useEffect, useState } from 'react';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import ProductImportsApi from '../../../../services/api/ProductImportsApi';

export default function DisplayMatching() {
  const [products, setProducts] = useState(null);
  
  const getMatchings = async () => {
    const res = await ProductImportsApi.getMatches();
    if (res.status === StatusCodes.OK) {
      setProducts(res.data);
    }
  };

  useEffect(() => {
    getMatchings();
  }, []);

  return (
    <WhitePad>
      <table>
        {products &&
          products.map((item) => {
            return (
              <tr>
                <td border="1">{item.nameChocolateSite}</td>
                <td border="1">{item.gtinCu}</td>
              </tr>
            );
          })}
      </table>
    </WhitePad>
  );
}
